import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UtilitaService } from '../services/utilita.service';
import { DipartimentiDettaglioComponent } from './dipartimenti-dettaglio/dipartimenti-dettaglio.component';

@Component({
  selector: 'app-dipartimenti',
  templateUrl: './dipartimenti.component.html',
  styleUrls: ['./dipartimenti.component.css']
})
export class DipartimentiComponent implements OnInit {
  lstAtenei: any;
  txtAteneo: string = "";
  lstElenco: any;
  lstElencoPerUpdateFilter: any;
  txtFiltra: any;

  constructor(private srvUtilita: UtilitaService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getAteneo();

  }

  getAteneo() {
    this.srvUtilita.getLista('Utenti/GetAteneiLista').subscribe((res: any) => {
      this.lstAtenei = res
     // console.log('atenei', res)

      this.getLista(this.txtAteneo)
    }, (err: any) => {
    })
  }

  getLista(idAteneo: any) {
    let ateneo: any = this.txtAteneo;
    if (!ateneo) ateneo = 0;

    this.srvUtilita.getLista('Utenti/GetDipartimentiLista?idAteneo=' + ateneo).subscribe((res: any) => {
      this.lstElenco = res
      this.lstElencoPerUpdateFilter = res;
    //  console.log('this.lstElenco', res)
    }, (err: any) => {
    })
  }


  btnCerca() {
    this.txtFiltra = '';
    this.getAteneo();
  }

  btnAggiungiModifica(iValore: number) {
   // console.log('ivalore', iValore)
    let dialogRef: MatDialogRef<any> = this.dialog.open(DipartimentiDettaglioComponent, {
      width: '720px',
      disableClose: false,
      data: { iValore: iValore }
    })
    dialogRef.afterClosed()
      .subscribe((res: any) => {
        this.txtFiltra = '';
        this.getLista(this.txtAteneo);
      })
  }

  updateFilter(event: any) {
    const val = event.target.value.toLowerCase()
    const columns = Object.keys(this.lstElencoPerUpdateFilter[0])
    columns.splice(columns.length - 1)
    if (!columns.length) {
      return
    }
    this.lstElenco = this.lstElencoPerUpdateFilter;
    const rows = this.lstElenco.filter(function (d: any) {
      for (let i = 0; i <= columns.length; i++) {
        const column = columns[i]
        if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
          return true
        }
      }
    })
    this.lstElenco = rows
  }

}
